import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { IoChevronDown } from "react-icons/io5";
import { Icon } from "@iconify/react";
import { useSearchParams } from "react-router-dom";
import { Modal3 } from "../../../../components/DIsplay/Modal/Modal3";
import AssignChange from "../../../../components/order/Change/AssignChange";
import AddRemarkMessage from "../../../../components/order/Change/AddRemarkMessage";
import { enqueueSnackbar } from "notistack";
import Button1 from "../../../../components/form/Button1";
import ChangeDeclineModal from "../../../../components/order/Change/ChangeDeclineModal";
import ManualChangeQuote from "../../../../components/order/Change/ManualChangeQuote";
import submitChange from "../../../../controllers/booking/postTicketing/change/submitChange";
import reissue from "../../../../controllers/booking/postTicketing/change/reissue";
import { isGDSSupplier } from "../../../../data/flight/supplier/getSupplierName";
import ManualUpdate, {
  buildManualChangePayload,
} from "../../../../components/order/Change/ManualUpdate";
import ChangeSupplierOutcomeForm, {
  CHANGE_SUPPLIER_OUTCOME,
} from "../../../../components/order/Change/ChangeSupplierOutcomeForm";
import adminPayForChangeRequest from "../../../../controllers/booking/postTicketing/change/adminPayForChangeRequest";
import ChangeNextStepCard from "./ChangeNextStepCard";
import ChangeReviewModal from "./ChangeReviewModal";
import ChangeReviewCard from "./ChangeReviewCard";
import ChangeFareRulesModal from "./ChangeFareRulesModal";
import ChangeSelectedOfferModal from "./ChangeSelectedOfferModal";
import ChangeMessagesModal from "./ChangeMessagesModal";
import ChangeBankTransferProofModal from "./ChangeBankTransferProofModal";
import SupplierResponseModal from "../../../../components/order/Void/SupplierResponseView";
import OpenTicketReviewModal from "../OpenTicket/OpenTicketReviewModal";
import StaffAsyncActionModal from "../../../../components/order/StaffAsyncActionModal";
import { getStaffApiErrorCopy } from "../../../../components/order/StaffApiErrorModal";
import manualChange from "../../../../controllers/booking/postTicketing/change/manualChange";
import proceedOpenTicketWithSupplier from "../../../../controllers/booking/postTicketing/change/proceedOpenTicketWithSupplier";
import recordOpenTicketOutcome from "../../../../controllers/booking/postTicketing/change/recordOpenTicketOutcome";
import {
  CHANGE_ACTION,
  OPEN_TICKET_OUTCOME,
  getChangeAdminGuidance,
  getChangeAdminStage,
  getChangeManualWarningCopy,
  getChangeOverflowMenuActions,
  getChangeReissueCopy,
  getChangeReissueWarningCopy,
  getChangeSubmitCopy,
  getChangeSubmitWarningCopy,
  getChangeRetryAutoActionLabel,
  getChangeRetryAutoConfirmLabel,
  getChangeRetryAutoCopy,
  getChangeRetryAutoLoadingTitle,
  getChangeRetryAutoWarningCopy,
  getOpenTicketOpenedCopy,
  getOpenTicketOpenedWarningCopy,
  getOpenTicketProceedCopy,
  getOpenTicketProceedWarningCopy,
  hasChangeQuote,
  isOpenTicketChange,
  needsChangeReview,
  canEnterChangeQuote,
} from "../../../../data/flight/order/getChangeAdminGuidance";

function ChangeConfirmationManageOrder({ data, showBanner = true }) {
  const [manageMenu, setManageMenu] = useState(false);
  const [searchParams] = useSearchParams();
  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  const [modal, setModal] = useState({
    assignTask: false,
    remark: false,
    reject: false,
    review: false,
    quote: false,
    confirm: false,
    adminPay: false,
    action: false,
    manualForm: false,
    fareRules: false,
    selectedOffer: false,
    supplierOutcome: false,
    messages: false,
    bankProof: false,
    supplierResponse: false,
  });
  const [openTicketStep, setOpenTicketStep] = useState("review");
  const [supplierOutcomeKind, setSupplierOutcomeKind] = useState(
    CHANGE_SUPPLIER_OUTCOME.decline,
  );
  const [loading, setLoading] = useState({
    reject: false,
    approve: false,
    submission: false,
    adminPay: false,
  });
  const [actionResult, setActionResult] = useState({
    phase: "loading",
    kind: "",
    title: "",
    text: "",
  });
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        manageMenu &&
        !menuRef.current?.contains(event.target) &&
        !buttonRef.current?.contains(event.target)
      ) {
        setManageMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [manageMenu]);

  useEffect(() => {
    const modalParam = searchParams.get("modal");
    if (!modalParam) return;
    const key = modalParam === "approve" ? "review" : modalParam;
    if (key === "quote" && !canEnterChangeQuote(data)) return;
    setModal((prev) => ({
      ...prev,
      [key]: true,
    }));
  }, [searchParams, data]);

  const og = {
    ...data,
    flightBooking: [data?.flightBooking],
    flightObj: data?.flightBooking,
    type: "Flight",
  };

  const guidance = getChangeAdminGuidance(data);
  const stage = getChangeAdminStage(data);
  const quoted = hasChangeQuote(data);
  const gds = isGDSSupplier(og?.supplier || og?.flightObj?.supplier);
  const isOpenTicket = isOpenTicketChange(data);

  const reviewNeeded = needsChangeReview(data);

  const menuActionMap = {
    [CHANGE_ACTION.review]: () => openReviewModal("review"),
    [CHANGE_ACTION.accept]: () => openReviewModal("review"),
    [CHANGE_ACTION.startOpen]: () => openReviewModal("review"),
    [CHANGE_ACTION.assign]: () => setModal({ ...modal, assignTask: true }),
    [CHANGE_ACTION.gdsReissue]: () => setModal({ ...modal, assignTask: true }),
    [CHANGE_ACTION.decline]: () => setModal({ ...modal, reject: true }),
    [CHANGE_ACTION.quote]: () => {
      if (!canEnterChangeQuote(data)) {
        openReviewModal("review");
        return;
      }
      setModal({ ...modal, quote: true });
    },
    [CHANGE_ACTION.adminPay]: () => setModal({ ...modal, adminPay: true }),
    [CHANGE_ACTION.reviewBankProof]: () =>
      setModal((prev) => ({ ...prev, bankProof: true })),
    [CHANGE_ACTION.submit]: () => promptSubmitChange(),
    [CHANGE_ACTION.retryAuto]: () => promptRetryAutoChange(),
    [CHANGE_ACTION.manualChange]: () => promptManualChange(),
    [CHANGE_ACTION.confirmReissue]: () => promptConfirmReissue(),
    [CHANGE_ACTION.remark]: () => setModal({ ...modal, remark: true }),
    [CHANGE_ACTION.fareRules]: () => setModal({ ...modal, fareRules: true }),
    [CHANGE_ACTION.viewSelectedOffer]: () =>
      setModal((prev) => ({ ...prev, selectedOffer: true })),
    [CHANGE_ACTION.messages]: () =>
      setModal((prev) => ({ ...prev, messages: true })),
    [CHANGE_ACTION.supplierResponse]: () =>
      setModal((prev) => ({ ...prev, supplierResponse: true })),
    [CHANGE_ACTION.proceedOpen]: () => promptProceedOpen(),
    [CHANGE_ACTION.notEligible]: () =>
      openReviewModal(stage === "needs_review" ? "review" : "processing"),
    [CHANGE_ACTION.recordOpened]: () => promptRecordOpened(),
    [CHANGE_ACTION.airlineDeclined]: () =>
      isOpenTicket
        ? openReviewModal("supplier")
        : openSupplierOutcome(CHANGE_SUPPLIER_OUTCOME.decline),
    [CHANGE_ACTION.processingFailed]: () =>
      isOpenTicket
        ? openReviewModal("supplier")
        : openSupplierOutcome(CHANGE_SUPPLIER_OUTCOME.technical),
    [CHANGE_ACTION.needMoreInfo]: () => openReviewModal("supplier"),
  };

  const menuItems = getChangeOverflowMenuActions(data)
    .map((action) => ({
      label: action.label,
      action: menuActionMap[action.key],
    }))
    .filter((item) => item.action);

  function openReviewModal(step = "review") {
    setOpenTicketStep(step);
    setModal((prev) => ({ ...prev, review: true }));
  }

  function openSupplierOutcome(kind) {
    setSupplierOutcomeKind(kind);
    setModal((prev) => ({ ...prev, supplierOutcome: true }));
  }

  async function handleSubmitChange() {
    setLoading({ ...loading, submission: true });
    setActionResult({
      phase: "loading",
      kind: "submitting",
      title: "",
      text: "",
    });
    const res = await submitChange(data?._id).finally(() =>
      setLoading({ ...loading, submission: false }),
    );
    setActionResult(getChangeSubmitCopy(res));
  }

  function promptConfirmReissue() {
    setActionResult(getChangeReissueWarningCopy(data));
    setModal((prev) => ({ ...prev, action: true, manualForm: false }));
  }

  async function handleConfirmReissue() {
    setLoading((prev) => ({ ...prev, submission: true }));
    setActionResult({
      phase: "loading",
      kind: "reissuing",
      title: "",
      text: "",
    });
    const res = await manualChange(buildManualChangePayload(og)).finally(() =>
      setLoading((prev) => ({ ...prev, submission: false })),
    );
    setActionResult(getChangeReissueCopy(res));
  }

  function promptSubmitChange() {
    setActionResult(getChangeSubmitWarningCopy(data));
    setModal((prev) => ({ ...prev, action: true, manualForm: false }));
  }

  function promptRetryAutoChange() {
    setActionResult(getChangeRetryAutoWarningCopy(data));
    setModal((prev) => ({ ...prev, action: true, manualForm: false }));
  }

  async function handleRetryAutoChange() {
    setLoading((prev) => ({ ...prev, submission: true }));
    setActionResult({
      phase: "loading",
      kind: "retry_autoing",
      title: "",
      text: "",
    });
    const res = await reissue({ changeOrderId: data?._id }).finally(() =>
      setLoading((prev) => ({ ...prev, submission: false })),
    );
    setActionResult(getChangeRetryAutoCopy(res));
  }

  function promptManualChange() {
    setActionResult(getChangeManualWarningCopy(data));
    setModal((prev) => ({ ...prev, action: true, manualForm: false }));
  }

  function promptProceedOpen() {
    setActionResult(getOpenTicketProceedWarningCopy());
    setModal((prev) => ({ ...prev, action: true, manualForm: false }));
  }

  async function handleProceedOpen() {
    setLoading((prev) => ({ ...prev, submission: true }));
    setActionResult({
      phase: "loading",
      kind: "open_proceeding",
      title: "",
      text: "",
    });
    const res = await proceedOpenTicketWithSupplier(data?._id).finally(() =>
      setLoading((prev) => ({ ...prev, submission: false })),
    );
    setActionResult(getOpenTicketProceedCopy(res));
  }

  function promptRecordOpened() {
    setActionResult(getOpenTicketOpenedWarningCopy());
    setModal((prev) => ({ ...prev, action: true, manualForm: false }));
  }

  async function handleRecordOpened() {
    setLoading((prev) => ({ ...prev, submission: true }));
    setActionResult({
      phase: "loading",
      kind: "open_opening",
      title: "",
      text: "",
    });
    const res = await recordOpenTicketOutcome(data?._id, {
      outcome: OPEN_TICKET_OUTCOME.SUCCESS,
    }).finally(() => setLoading((prev) => ({ ...prev, submission: false })));
    setActionResult(getOpenTicketOpenedCopy(res));
  }

  function closeActionModal() {
    setModal((prev) => ({ ...prev, action: false }));
  }

  function showApiError(res, title) {
    setActionResult(getStaffApiErrorCopy(res, title));
    setModal((prev) => ({
      ...prev,
      action: true,
      reject: false,
      adminPay: false,
    }));
  }

  function getActionModalActions() {
    const kind = actionResult.kind;
    const trySubmit = {
      label: "Try again",
      onClick: () => handleSubmitChange(),
    };
    const assign = {
      label: "Give to a teammate",
      onClick: () => {
        closeActionModal();
        setModal((prev) => ({ ...prev, assignTask: true }));
      },
    };
    const seeLatest = {
      label: "See the latest status",
      primary: true,
      onClick: () => window.location.reload(),
    };
    const yesSubmit = {
      label: "Yes, sent to airline",
      primary: true,
      onClick: () => handleSubmitChange(),
    };
    const yesRetryAuto = {
      label: getChangeRetryAutoConfirmLabel(),
      primary: true,
      onClick: () => handleRetryAutoChange(),
    };
    const tryRetryAuto = {
      label: "Try again",
      onClick: () => handleRetryAutoChange(),
    };
    const yesManual = {
      label: "Yes, I already completed it",
      onClick: () => {
        closeActionModal();
        setModal((prev) => ({ ...prev, manualForm: true }));
      },
    };
    const yesReissue = {
      label: "Yes, the airline reissued it",
      primary: true,
      onClick: () => handleConfirmReissue(),
    };
    const tryReissue = {
      label: "Try again",
      onClick: () => handleConfirmReissue(),
    };
    const tryOpenedOpen = {
      label: "Try again",
      onClick: () => handleRecordOpened(),
    };
    const yesProceedOpen = {
      label: "Yes, proceed with the airline",
      primary: true,
      onClick: () => handleProceedOpen(),
    };
    const tryProceedOpen = {
      label: "Try again",
      onClick: () => handleProceedOpen(),
    };
    const yesOpenedOpen = {
      label: "Yes, the airline opened it",
      primary: true,
      onClick: () => handleRecordOpened(),
    };
    const goBack = {
      label: "Go back",
      onClick: closeActionModal,
    };
    const switchToManual = {
      label: "Record a manual change",
      onClick: () => promptManualChange(),
    };

    switch (kind) {
      case "retry_auto_warn":
        return [yesRetryAuto, goBack];
      case "submit_warn":
        return [yesSubmit, goBack];
      case "manual_warn":
        return [yesManual, goBack];
      case "reissue_warn":
        return [yesReissue, goBack];
      case "open_proceed_warn":
        return [yesProceedOpen, goBack];
      case "open_opened_warn":
        return [yesOpenedOpen, goBack];
      case "submitted":
      case "reissued":
      case "retry_autoed":
      case "open_proceeded":
      case "open_opened":
        return [seeLatest];
      case "retry_auto_failed":
        return [{ ...tryRetryAuto, primary: true }];
      case "submit_failed":
        return [trySubmit, switchToManual, assign];
      case "reissue_failed":
        return [tryReissue, assign];
      case "open_proceed_failed":
        return [tryProceedOpen, assign];
      case "open_opened_failed":
        return [tryOpenedOpen, assign];
      case "api_error":
        return [{ label: "OK", primary: true, onClick: closeActionModal }];
      default:
        return [goBack];
    }
  }

  async function handleAdminPay() {
    setLoading({ ...loading, adminPay: true });
    const res = await adminPayForChangeRequest({
      changeOrderId: data?._id,
    }).finally(() => setLoading({ ...loading, adminPay: false }));
    if (res?.return) {
      enqueueSnackbar(
        res?.msg || "Payment taken from the agent wallet. Submit to the airline next.",
        { variant: "success" },
      );
      setTimeout(() => window.location.reload(), 300);
    } else showApiError(res, "We could not take payment");
  }

  function handleAction(key) {
    const run = menuActionMap[key];
    if (run) run();
  }

  return (
    <>
      {showBanner ? (
        <ChangeNextStepCard
          data={data}
          loading={{
            [CHANGE_ACTION.review]: loading.approve,
            [CHANGE_ACTION.accept]: loading.approve,
            [CHANGE_ACTION.decline]: loading.reject,
            [CHANGE_ACTION.submit]: loading.submission,
            [CHANGE_ACTION.confirmReissue]: loading.submission,
            [CHANGE_ACTION.adminPay]: loading.adminPay,
            [CHANGE_ACTION.proceedOpen]: loading.submission,
            [CHANGE_ACTION.recordOpened]: loading.submission,
          }}
          onAction={handleAction}
        />
      ) : null}
      {showBanner && reviewNeeded && !isOpenTicket ? (
        <ChangeReviewCard data={data} />
      ) : null}

      {isOpenTicket ? (
        <OpenTicketReviewModal
          open={modal.review}
          setOpen={(open) => setModal({ ...modal, review: open })}
          data={data}
          step={openTicketStep}
          onDone={() => window.location.reload()}
          onProceed={() => promptProceedOpen()}
          onOpened={() => promptRecordOpened()}
        />
      ) : (
        <ChangeReviewModal
          open={modal.review}
          setOpen={(open) =>
            setModal((prev) => ({ ...prev, review: Boolean(open) }))
          }
          data={data}
          onDone={() => window.location.reload()}
          onViewSelectedOffer={() =>
            setModal((prev) => ({ ...prev, selectedOffer: true }))
          }
          onQuote={() => setModal((prev) => ({ ...prev, review: false, quote: true }))}
          onSubmit={() => {
            setModal((prev) => ({ ...prev, review: false }));
            promptSubmitChange();
          }}
          onManualChange={() => {
            setModal((prev) => ({ ...prev, review: false }));
            promptManualChange();
          }}
        />
      )}

      <ChangeSelectedOfferModal
        open={modal.selectedOffer}
        setOpen={(open) =>
          setModal((prev) => ({ ...prev, selectedOffer: Boolean(open) }))
        }
        data={data}
      />

      <ChangeMessagesModal
        open={modal.messages}
        setOpen={(open) =>
          setModal((prev) => ({ ...prev, messages: Boolean(open) }))
        }
        data={data}
      />

      <SupplierResponseModal
        open={modal.supplierResponse}
        setOpen={(open) =>
          setModal((prev) => ({ ...prev, supplierResponse: Boolean(open) }))
        }
        data={data?.supplierResponse}
        orderId={data?.orderId}
      />

      <ChangeBankTransferProofModal
        open={modal.bankProof}
        setOpen={(open) =>
          setModal((prev) => ({ ...prev, bankProof: Boolean(open) }))
        }
        data={data}
        onUpdated={() => window.location.reload()}
      />

      <Modal3
        open={modal.adminPay}
        setOpen={(modalState) => setModal({ ...modal, adminPay: modalState })}
        title="Pay from agent wallet"
      >
        <div className="card p-4 flex flex-col gap-4 min-w-[300px]">
          <div className="py-4">
            This takes the quoted change charge from the agent wallet. Only do
            this if the agent cannot pay themselves. Do not submit to the airline
            until this succeeds.
          </div>
          <div className="flex justify-end items-center gap-4">
            <Button1
              variant="outlined"
              className="btn-outlined flex-1"
              onClick={() => setModal({ ...modal, adminPay: false })}
            >
              Back
            </Button1>
            <div>
              <Button1
                onClick={() => handleAdminPay()}
                loading={loading?.adminPay}
              >
                Take payment
              </Button1>
            </div>
          </div>
        </div>
      </Modal3>
      <Modal3
        open={modal.confirm}
        setOpen={(modalState) => setModal({ ...modal, confirm: modalState })}
        title="Confirm re-issue"
      >
        <div className="p-4 max-w-[700px]">
          <ManualUpdate
            callback={() => window.location.reload()}
            data={og}
            close={() => setModal({ ...modal, confirm: false })}
          />
        </div>
      </Modal3>
      <StaffAsyncActionModal
        open={modal.action}
        setOpen={(open) => setModal((prev) => ({ ...prev, action: open }))}
        title={
          actionResult.kind === "api_error"
            ? actionResult.title
            : ["open_proceed_warn", "open_proceeding", "open_proceeded", "open_proceed_failed"].includes(
            actionResult.kind,
          )
            ? "Proceed with the airline"
            : ["open_opened_warn", "open_opening", "open_opened", "open_opened_failed"].includes(
                actionResult.kind,
              )
              ? "Record opened"
            : ["manual_warn"].includes(actionResult.kind)
            ? "Record a manual change"
            : [
                "retry_auto_warn",
                "retry_autoing",
                "retry_autoed",
                "retry_auto_failed",
              ].includes(actionResult.kind)
              ? getChangeRetryAutoActionLabel()
            : ["reissue_warn", "reissuing", "reissued", "reissue_failed"].includes(
                actionResult.kind,
              )
              ? "Confirm re-issue"
              : "Confirm sent to airline"
        }
        phase={actionResult.phase}
        loadingTitle={
          actionResult.kind === "retry_autoing"
            ? getChangeRetryAutoLoadingTitle()
            : actionResult.kind === "reissuing"
            ? "Writing the new ticket into Intraverse"
            : actionResult.kind === "open_opening"
              ? "Writing OPEN into Intraverse"
              : actionResult.kind === "open_proceeding"
                ? "Moving this to the airline"
            : "Telling Intraverse this has been sent"
        }
        loadingText="This can take a few seconds. Stay on this screen. Do not click again. A timeout is not an airline decline."
        resultTitle={actionResult.title}
        resultText={actionResult.text}
        actions={getActionModalActions()}
      />

      {modal.manualForm
        ? ReactDOM.createPortal(
            <div className="fixed inset-0 z-[80] flex items-center justify-center p-4">
              <button
                type="button"
                aria-label="Close overlay"
                className="absolute inset-0 bg-black/40"
                onClick={() =>
                  setModal((prev) => ({ ...prev, manualForm: false }))
                }
              />
              <div className="relative w-full max-w-[560px] max-h-[90vh] overflow-y-auto rounded-2xl bg-white shadow-2xl p-6">
                <div className="flex items-start justify-between gap-4 mb-4">
                  <div>
                    <h2 className="text-[17px] font-semibold text-gray-900 leading-6">
                      Record a manual change
                    </h2>
                    <p className="mt-1 text-sm text-gray-500">
                      Use this only if you already completed this{" "}
                      {guidance.kind} with the airline. This writes the new
                      ticket into Intraverse.
                    </p>
                  </div>
                  <button
                    type="button"
                    onClick={() =>
                      setModal((prev) => ({ ...prev, manualForm: false }))
                    }
                    className="mt-0.5 rounded-full p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-700"
                  >
                    <Icon icon="material-symbols:close" className="text-xl" />
                  </button>
                </div>
                <ManualUpdate
                  callback={() => window.location.reload()}
                  data={og}
                  close={() =>
                    setModal((prev) => ({ ...prev, manualForm: false }))
                  }
                />
              </div>
            </div>,
            document.body,
          )
        : null}

      <Modal3
        open={modal.quote}
        setOpen={(modalState) => setModal({ ...modal, quote: modalState })}
        title={
          quoted ? `Edit ${guidance.kind} quote` : `Enter ${guidance.kind} quote`
        }
      >
        <div className="p-4 max-w-[800px] md:min-w-[500px]">
          <ManualChangeQuote
            data={og}
            reload={() => window.location.reload()}
            close={() => setModal({ ...modal, quote: false })}
            onViewSelectedOffer={() =>
              setModal((prev) => ({ ...prev, selectedOffer: true }))
            }
          />
        </div>
      </Modal3>

      <ChangeFareRulesModal
        data={data}
        open={modal.fareRules}
        setOpen={(next) =>
          setModal((prev) => ({ ...prev, fareRules: Boolean(next) }))
        }
      />

      <Modal3
        open={modal.supplierOutcome}
        setOpen={(modalState) =>
          setModal({ ...modal, supplierOutcome: modalState })
        }
        title="Record airline / supplier result"
      >
        <div className="p-4">
          <ChangeSupplierOutcomeForm
            data={data}
            initialKind={supplierOutcomeKind}
            callback={() => setTimeout(() => window.location.reload(), 300)}
            close={() => setModal({ ...modal, supplierOutcome: false })}
          />
        </div>
      </Modal3>

      <ChangeDeclineModal
        open={modal.reject}
        setOpen={(modalState) => setModal({ ...modal, reject: modalState })}
        data={data}
        onDone={() => {
          setModal((prev) => ({ ...prev, reject: false }));
          setTimeout(() => window.location.reload(), 300);
        }}
      />
      <Modal3
        open={modal.assignTask}
        setOpen={(modalState) => setModal({ ...modal, assignTask: modalState })}
        title={
          gds && stage === "needs_reissue" ? "GDS re-issue" : "Assign change"
        }
      >
        <div className="p-4 max-w-[700px]">
          <AssignChange callback={() => window.location.reload()} data={og} />
        </div>
      </Modal3>
      <Modal3
        open={modal.remark}
        setOpen={(modalState) => setModal({ ...modal, remark: modalState })}
        title="Add an update"
      >
        <div className="card p-4 flex flex-col gap-4 md:min-w-[500px]">
          <AddRemarkMessage
            callback={() => window.location.reload()}
            data={og}
          />
        </div>
      </Modal3>

      {menuItems?.length ? (
        <div className="relative w-full lg:w-fit ml-auto mt-2">
          <button
            ref={buttonRef}
            onClick={() => setManageMenu((prev) => !prev)}
            className="border border-gray-300 h-12 rounded-md bg-gray-100 hover:bg-gray-200 transition-all w-full px-2 lg:px-4 flex items-center justify-center gap-2 text-sm font-semibold"
          >
            <span>More actions</span>
            <IoChevronDown
              className={`text-base transition-transform mt-[2px] ${
                manageMenu ? "rotate-180" : ""
              }`}
            />
          </button>

          {manageMenu && (
            <div
              ref={menuRef}
              className="absolute right-0 mt-2 w-56 rounded-md border border-gray-200 bg-white shadow-lg overflow-hidden z-20"
            >
              <div className="px-3 py-2 text-xs text-gray-500 border-b border-gray-100">
                Current: {guidance.statusLabel}
              </div>
              {menuItems.map((itm, idx) => (
                <button
                  key={idx}
                  onClick={() => {
                    setManageMenu(false);
                    itm.action?.();
                  }}
                  className="w-full text-left px-3 py-2 text-sm hover:bg-gray-50"
                >
                  {itm.label}
                </button>
              ))}
            </div>
          )}
        </div>
      ) : null}
    </>
  );
}

export default ChangeConfirmationManageOrder;
